// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-window {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.chat-window .chat-window-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.chat-window .chat-window-card ::ng-deep .ant-card-body {
  height: calc(100% - 55px);
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
}
.chat-window .chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  flex-shrink: 0;
}
.chat-window .chat-header .chat-title {
  display: flex;
  align-items: center;
  gap: 12px;
}
.chat-window .chat-header .chat-title .group-name {
  font-size: 16px;
  font-weight: 500;
}
.chat-window .messages-container {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background: #f8f9fa;
  min-height: 0;
}
.chat-window .messages-container .message-card {
  max-width: 80%;
  margin: 8px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
  padding: 12px;
  min-width: 400px;
}
.chat-window .messages-container .message-seller .message-card {
  margin-left: auto;
  background: #e6f7ff;
}
.chat-window .messages-container .message-buyer .message-card {
  margin-right: auto;
  background: #f6ffed;
}
.chat-window .messages-container .message-admin .message-card {
  margin-right: auto;
  background: #fff7e6;
}
.chat-window .messages-container .message-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
}
.chat-window .messages-container .message-header .sender-name {
  font-weight: 500;
  border-radius: 4px;
}
.chat-window .messages-container .message-header .sender-name nz-tag {
  margin-left: 4px;
}
.chat-window .messages-container .message-header .message-time {
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
}
.chat-window .messages-container .message-content {
  white-space: pre-wrap;
  word-break: break-word;
}
.chat-window .messages-container .message-attachments {
  margin-top: 8px;
  display: flex;
  gap: 8px;
}
.chat-window .input-container {
  padding: 16px;
  background: white;
  border-top: 1px solid #f0f0f0;
  flex-shrink: 0;
}
.chat-window .input-container .input-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f5f5f5;
  border-radius: 24px;
  padding: 4px;
  border: 1px solid #d9d9d9;
  transition: all 0.3s;
}
.chat-window .input-container .input-wrapper:hover, .chat-window .input-container .input-wrapper:focus-within {
  border-color: #40a9ff;
  background: white;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}
.chat-window .input-container .input-wrapper .attachment-btn {
  color: #595959;
}
.chat-window .input-container .input-wrapper .attachment-btn:hover {
  color: #40a9ff;
}
.chat-window .input-container .input-wrapper input {
  flex: 1;
  border: none;
  background: transparent;
  padding: 8px;
}
.chat-window .input-container .input-wrapper input:focus {
  box-shadow: none;
}
.chat-window .input-container .input-wrapper .send-btn {
  width: 36px;
  height: 36px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.chat-window .input-container .input-wrapper .send-btn i {
  font-size: 16px;
}
.chat-window .input-container .selected-files {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.chat-window .input-container .selected-files .file-tag {
  display: flex;
  align-items: center;
  gap: 4px;
}

::ng-deep .ant-btn-circle {
  transition: transform 0.2s;
}
::ng-deep .ant-btn-circle:hover {
  transform: scale(1.05);
}
::ng-deep .ant-btn-circle:active {
  transform: scale(0.95);
}
::ng-deep .ant-input::placeholder {
  color: #bfbfbf;
}

.count {
  padding-left: 8px;
  cursor: auto;
}

.ant-comment-rtl .count {
  padding-right: 8px;
  padding-left: 0;
}

.archived {
  background: #f5f5f5;
  border-color: #e8e8e8;
  opacity: 0.65;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/app/main/chat/attender-chat-window/attender-chat-window.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AACF;AACE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AACJ;AACI;EACE,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;AACN;AAGE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AADJ;AAGI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AADN;AAGM;EACE,eAAA;EACA,gBAAA;AADR;AAME;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;AAJJ;AAMI;EACE,cAAA;EACA,aAAA;EACA,yCAAA;EACA,aAAA;EACA,gBAAA;AAJN;AAOI;EACE,iBAAA;EACA,mBAAA;AALN;AAQI;EACE,kBAAA;EACA,mBAAA;AANN;AASI;EACE,kBAAA;EACA,mBAAA;AAPN;AAUI;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;AARN;AAUM;EACE,gBAAA;EACA,kBAAA;AARR;AASQ;EACE,gBAAA;AAPV;AAWM;EACE,0BAAA;EACA,eAAA;AATR;AAaI;EACE,qBAAA;EACA,sBAAA;AAXN;AAcI;EACE,eAAA;EACA,aAAA;EACA,QAAA;AAZN;AAgBE;EACE,aAAA;EACA,iBAAA;EACA,6BAAA;EACA,cAAA;AAdJ;AAgBI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,oBAAA;AAdN;AAgBM;EACE,qBAAA;EACA,iBAAA;EACA,6CAAA;AAdR;AAiBM;EACE,cAAA;AAfR;AAiBQ;EACE,cAAA;AAfV;AAmBM;EACE,OAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;AAjBR;AAmBQ;EACE,gBAAA;AAjBV;AAqBM;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAnBR;AAqBQ;EACE,eAAA;AAnBV;AAwBI;EACE,eAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;AAtBN;AAwBM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAtBR;;AA8BE;EACE,0BAAA;AA3BJ;AA6BI;EACE,sBAAA;AA3BN;AA8BI;EACE,sBAAA;AA5BN;AAiCI;EACE,cAAA;AA/BN;;AAqCA;EACE,iBAAA;EACA,YAAA;AAlCF;;AAoCA;EACE,kBAAA;EACA,eAAA;AAjCF;;AAoCA;EACE,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;AAjCF","sourcesContent":[".chat-window {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  .chat-window-card {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n\n    ::ng-deep .ant-card-body {\n      height: calc(100% - 55px);\n      display: flex;\n      flex-direction: column;\n      padding: 0;\n      overflow: hidden; // Prevent scrollbar on the card body\n    }\n  }\n\n  .chat-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px;\n    flex-shrink: 0; // Prevent header from shrinking\n\n    .chat-title {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n\n      .group-name {\n        font-size: 16px;\n        font-weight: 500;\n      }\n    }\n  }\n\n  .messages-container {\n    flex: 1;\n    overflow-y: auto;\n    padding: 16px;\n    background: #f8f9fa;\n    min-height: 0; // Allow container to scroll\n\n    .message-card {\n      max-width: 80%;\n      margin: 8px 0;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);\n      padding: 12px;\n      min-width: 400px;\n    }\n\n    .message-seller .message-card {\n      margin-left: auto;\n      background: #e6f7ff;\n    }\n\n    .message-buyer .message-card {\n      margin-right: auto;\n      background: #f6ffed;\n    }\n\n    .message-admin .message-card {\n      margin-right: auto;\n      background: #fff7e6;\n    }\n\n    .message-header {\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 4px;\n\n      .sender-name {\n        font-weight: 500;\n        border-radius: 4px;\n        nz-tag {\n          margin-left: 4px;\n        }\n      }\n\n      .message-time {\n        color: rgba(0, 0, 0, 0.45);\n        font-size: 12px;\n      }\n    }\n\n    .message-content {\n      white-space: pre-wrap;\n      word-break: break-word;\n    }\n\n    .message-attachments {\n      margin-top: 8px;\n      display: flex;\n      gap: 8px;\n    }\n  }\n\n  .input-container {\n    padding: 16px;\n    background: white;\n    border-top: 1px solid #f0f0f0;\n    flex-shrink: 0;\n\n    .input-wrapper {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      background: #f5f5f5;\n      border-radius: 24px;\n      padding: 4px;\n      border: 1px solid #d9d9d9;\n      transition: all 0.3s;\n\n      &:hover, &:focus-within {\n        border-color: #40a9ff;\n        background: white;\n        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);\n      }\n\n      .attachment-btn {\n        color: #595959;\n\n        &:hover {\n          color: #40a9ff;\n        }\n      }\n\n      input {\n        flex: 1;\n        border: none;\n        background: transparent;\n        padding: 8px;\n\n        &:focus {\n          box-shadow: none;\n        }\n      }\n\n      .send-btn {\n        width: 36px;\n        height: 36px;\n        padding: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        i {\n          font-size: 16px;\n        }\n      }\n    }\n\n    .selected-files {\n      margin-top: 8px;\n      display: flex;\n      flex-wrap: wrap;\n      gap: 8px;\n\n      .file-tag {\n        display: flex;\n        align-items: center;\n        gap: 4px;\n      }\n    }\n  }\n}\n\n\n::ng-deep {\n  .ant-btn-circle {\n    transition: transform 0.2s;\n\n    &:hover {\n      transform: scale(1.05);\n    }\n\n    &:active {\n      transform: scale(0.95);\n    }\n  }\n\n  .ant-input {\n    &::placeholder {\n      color: #bfbfbf;\n    }\n  }\n}\n\n\n.count {\n  padding-left: 8px;\n  cursor: auto;\n}\n.ant-comment-rtl .count {\n  padding-right: 8px;\n  padding-left: 0;\n}\n\n.archived {\n  background: #f5f5f5;\n  border-color: #e8e8e8;\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
